var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 0.833313C10.6825 0.833313 13.6673 3.81808 13.6673 7.49998C13.6673 11.1819 10.6825 14.1666 7.00065 14.1666C3.31875 14.1666 0.333984 11.1819 0.333984 7.49998C0.333984 3.81808 3.31875 0.833313 7.00065 0.833313ZM7.00065 2.16665C4.05513 2.16665 1.66732 4.55446 1.66732 7.49998C1.66732 10.4455 4.05513 12.8333 7.00065 12.8333C9.94617 12.8333 12.334 10.4455 12.334 7.49998C12.334 4.55446 9.94617 2.16665 7.00065 2.16665ZM7.00065 6.16665C7.36884 6.16665 7.66732 6.46512 7.66732 6.83331V10.8333C7.66732 11.2015 7.36884 11.5 7.00065 11.5C6.63246 11.5 6.33398 11.2015 6.33398 10.8333V6.83331C6.33398 6.46512 6.63246 6.16665 7.00065 6.16665ZM7.00065 3.49998C7.36884 3.49998 7.66732 3.79846 7.66732 4.16665C7.66732 4.53484 7.36884 4.83331 7.00065 4.83331C6.63246 4.83331 6.33398 4.53484 6.33398 4.16665C6.33398 3.79846 6.63246 3.49998 7.00065 3.49998Z",
    fill: "#999DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.227c7b90.svg";
export { ForwardRef as ReactComponent };